import styled from 'styled-components'
import { LogOut } from '@styled-icons/boxicons-regular/LogOut'

const LogOutIcon = styled(LogOut)`
  color: #000000;
`
export default LogOutIcon
